import React, { createElement as _createElement } from 'react';
import { useTop } from "../../hooks/useTop.js";
import { DataGridHeaderCell } from "../DataGridHeaderCell/DataGridHeaderCell.js";
import { StickyDataGridHeaderCell } from "../StickyDatagridHeaderCell/StickyDataGridHeaderCell.js";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const DataGridHeaderRow = /*#__PURE__*/React.memo(({
  stickyHeader,
  columnCount,
  hydratedColumns,
  lastColumnFixed,
  activeColumn,
  mode,
  rowAlternating,
  offsetTop,
  someHaveBody,
  changeOrder,
  dataGridRef,
  isOverflowing,
  fullyScrolledLeft,
  nextButton,
  headerBackgroundColor
}) => {
  const {
    isSticking,
    calculatedTop
  } = useTop(dataGridRef, offsetTop);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: hydratedColumns.map((column, i) => {
      const isLastColumn = i === columnCount - 1;
      const isLastButOneColumn = i === columnCount - 2;
      const isFixedRight = lastColumnFixed && isLastColumn || lastColumnFixed && someHaveBody && isLastButOneColumn;
      const key = `h_${i}`;
      const props = {
        isFirst: i === 0,
        isLast: isLastColumn,
        isAlternating: rowAlternating,
        isSticky: stickyHeader || false,
        offsetTop,
        order: activeColumn === column.name ? mode : undefined,
        onOrder: changeOrder,
        column,
        align: column.align || 'left',
        isFixedRight,
        hasBody: someHaveBody,
        isLastButOne: isLastButOneColumn,
        isOverflowing,
        fullyScrolledLeft,
        nextButton,
        headerBackgroundColor
      };

      // Only use StickyDataGridHeaderCell when both are true
      // * stickyHeader => general indicator if the header should be sticky
      // * isOverflowing => if the header and the content is not overflowing, the sticky behavior is handled in DataGridHeaderCell (via css) except...
      // * lastColumnFixed => ...the last column is fixed, then it should also use the Sticky component
      if (stickyHeader && (isOverflowing || lastColumnFixed)) {
        return /*#__PURE__*/_createElement(StickyDataGridHeaderCell, {
          ...props,
          key: key,
          isSticking: isSticking,
          calculatedTop: calculatedTop
        });
      }
      return /*#__PURE__*/_createElement(DataGridHeaderCell, {
        ...props,
        key: key
      });
    })
  });
});